import { h } from 'preact'
import { CalendarMonth } from './CalendarMonth'
import { Day } from './Day'
import { Weekdays } from './Weekdays'

interface CalendarProps {
  month: number
  year: number
  today: Date
  onChangeMonth: (offset: 1 | -1) => void
  onSelectDate: (day: number) => void
  selectedDate?: Date
  selectedStartDate?: Date
  selectedEndDate?: Date
}

function areDatesEqual (firstDate?: Date, secondDate?: Date) {
  if (!firstDate || !secondDate) {
    return false
  }

  firstDate.setHours(0, 0, 0, 0)
  secondDate.setHours(0, 0, 0, 0)

  return firstDate.getTime() === secondDate.getTime()
}

function isDateInRange (date: Date, rangeStart?: Date, rangeEnd?: Date) {
  if (!rangeStart || !rangeEnd) {
    return false
  }

  date.setHours(0, 0, 0, 0)
  rangeStart.setHours(0, 0, 0, 0)
  rangeEnd.setHours(0, 0, 0, 0)

  return date.getTime() >= rangeStart.getTime() && date.getTime() <= rangeEnd.getTime()
}

export const Calendar = (
  {
    month,
    year,
    selectedDate,
    selectedStartDate,
    selectedEndDate,
    today,
    onChangeMonth,
    onSelectDate
  }: CalendarProps) => {
  const startDay = new Date(year, month).getDay()
  const daysOfPreviousMonth = [...Array(startDay)].map((empty, idx) => (
    <Day key={(idx + 1) * -1} disabled />
  ))

  const daysCount = 32 - new Date(year, month, 32).getDate()
  const daysOfCurrentMonth = [...Array(daysCount)].map((empty, idx) => {
    const day = idx + 1
    const date = new Date(year, month, day)

    const isToday = areDatesEqual(date, today)
    const isRangeStart = areDatesEqual(date, selectedStartDate)
    const isRangeMiddle = isDateInRange(date, selectedStartDate, selectedEndDate)
    const isRangeEnd = areDatesEqual(date, selectedEndDate)
    const isSelected = areDatesEqual(date, selectedDate) || isRangeStart || isRangeEnd

    return (
      <Day
        key={day}
        today={isToday}
        onClick={onSelectDate}
        selected={isSelected}
        rangeStart={isRangeStart}
        rangeMiddle={isRangeMiddle}
        rangeEnd={isRangeEnd}
      >
        {day}
      </Day>
    )
  })

  return (
    <div className='m-calendar'>
      <CalendarMonth
        month={month}
        year={year}
        onChangeMonth={onChangeMonth}
      />
      <Weekdays />
      <div className='m-month-days'>
        {daysOfPreviousMonth}
        {daysOfCurrentMonth}
      </div>
    </div>
  )
}
